export default __webpack_public_path__ + "static/media/icon_corporate_on.987fc6d8.svg";